import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconSliceSearch = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--slice-search")} iconColor={color} size={size} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_4102_6383" style={{ maskType: "alpha", }} maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
  <rect x="0.5" width="24" height="24" fill="currentColor"/>
  </mask>
  <g mask="url(#mask0_4102_6383)">
  <path d="M19.9846 20.1539L13.723 13.8923C13.223 14.318 12.648 14.6474 11.998 14.8808C11.348 15.1141 10.6948 15.2308 10.0384 15.2308C8.43673 15.2308 7.08118 14.6764 5.97177 13.5676C4.86233 12.4587 4.30762 11.1039 4.30762 9.50313C4.30762 7.90233 4.86203 6.54648 5.97084 5.43558C7.07966 4.32468 8.43447 3.76923 10.0353 3.76923C11.6361 3.76923 12.9919 4.32393 14.1028 5.43335C15.2137 6.54277 15.7692 7.89832 15.7692 9.5C15.7692 10.1949 15.6461 10.8673 15.3999 11.5173C15.1538 12.1673 14.8307 12.7231 14.4307 13.1846L20.6923 19.4462L19.9846 20.1539ZM10.0384 14.2308C11.3653 14.2308 12.4855 13.774 13.399 12.8606C14.3124 11.9471 14.7692 10.8269 14.7692 9.5C14.7692 8.17309 14.3124 7.05289 13.399 6.13943C12.4855 5.22596 11.3653 4.76923 10.0384 4.76923C8.71147 4.76923 7.59128 5.22596 6.67782 6.13943C5.76437 7.05289 5.30764 8.17309 5.30764 9.5C5.30764 10.8269 5.76437 11.9471 6.67782 12.8606C7.59128 13.774 8.71147 14.2308 10.0384 14.2308Z" fill="currentColor"/>
  </g>
  </IconWrapper>
)
